import { useCart } from '../contexts/CartContext';
import { useNavigate } from 'react-router-dom';
import './scss/CartModal.scss';
import Button from './ui/Button';
import { useCurrency } from '../contexts/CurrencyContext';
import ApiImage from './ApiImage';
import api from "../api";
import { useContext, useState, useEffect } from 'react';
import LoaderBlock from './ui/LoaderBlock';
import qs from 'qs';

const CartModal = () => {
  const {
    cartItems,
    removeFromCart,
    updateQuantity,
    setIsCartOpen,
    isCartOpen
  } = useCart();
  const navigate = useNavigate();
  const { cny } = useCurrency();
  const [isLoad, setIsLoad] = useState(true);
  const [products, setProducts] = useState([]);
  const [lastColorHeader, setLastColorHeader] = useState("");

  const removeFromCartLocal = (id) => {
    removeFromCart(id);
    setProducts(prevProducts =>
      prevProducts.filter(product => product.id !== id)
    );
  }

  useEffect(() => {
    if (cartItems.length == 0) return;
    setIsLoad(true);
    const fetchProduct = async () => {
        try {
            const ids = cartItems.map(item => item.id);
            const response = await api.get('/api/products/UserProductsCart', {
              params: { id: ids },
              paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
            });
            const data = response.data;
            setProducts(data);
            setIsLoad(false);
        } catch (error) {
            console.error("Ошибка при загрузке товаров:", error);
        }
    };
    fetchProduct();
  }, [isCartOpen]);

  const handleCheckout = () => {
    navigate('/checkout');
  };

  const totalPrice = cartItems.reduce((sum, cartItem) => {
    const product = products.find(p => p.id === cartItem.id);
    if (!product) return sum;

    return (sum + Math.round((product.cost * cny)) * cartItem.quantity);
  }, 0);


  return (
    <div className="cart-modal-overlay" onClick={() => setIsCartOpen(false)}>
      <div className="cart-modal" style={{overflowY: isLoad ? "hidden" : "auto"}} onClick={(e) => e.stopPropagation()}>
        <h2>Корзина</h2>
        {isLoad ? (<LoaderBlock minHeight={"60vh"} />):(
          <>
          {products.map((item) => {
            const cartItem = cartItems.find(ci => ci.id === item.id);
            const quantity = cartItem?.quantity || 0;
            return (
              <div className="cart-item" key={item.id}>
                <div className='cart-main-info'>
                  <ApiImage path={item.mainImage} className='item-img'></ApiImage>
                  <div className="item-info">
                    <div className="item-price">
                      {Math.round(item.cost * cny)} ₽ <span className="item-cny">≈ {item.cost} ¥</span>
                    </div>
                    <div className="item-name">{item.name}</div>
                  </div>
                </div>
                <div className='cart-options-info'>
                  <button className="remove-btn" onClick={() => removeFromCartLocal(item.id)}>
                      Удалить
                  </button>
                  <div className="qty-stepper">
                    <button onClick={() => updateQuantity(item.id, quantity - 1)}>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.16663 9.99996C4.16663 9.53972 4.53972 9.16663 4.99996 9.16663L15 9.16663C15.4602 9.16663 15.8333 9.53972 15.8333 9.99996C15.8333 10.4602 15.4602 10.8333 15 10.8333L4.99996 10.8333C4.53972 10.8333 4.16663 10.4602 4.16663 9.99996Z" fill="white"/>
                      </svg>
                    </button>
                    <input
                      value={quantity}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (/^\d*$/.test(val)) {
                          updateQuantity(item.id, val);
                        }
                      }}
                    />
                    <button onClick={() => updateQuantity(item.id, quantity + 1)}>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.99996 4.16663C10.4602 4.16663 10.8333 4.53972 10.8333 4.99996V9.16663H15C15.4602 9.16663 15.8333 9.53972 15.8333 9.99996C15.8333 10.4602 15.4602 10.8333 15 10.8333H10.8333V15C10.8333 15.4602 10.4602 15.8333 9.99996 15.8333C9.53972 15.8333 9.16663 15.4602 9.16663 15V10.8333H4.99996C4.53972 10.8333 4.16663 10.4602 4.16663 9.99996C4.16663 9.53972 4.53972 9.16663 4.99996 9.16663H9.16663V4.99996C9.16663 4.53972 9.53972 4.16663 9.99996 4.16663Z" fill="white"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            )}
          )}
          <div className="cart-footer">
            <div className="total">
              <div className='price'>{totalPrice.toLocaleString()} ₽</div>
              <span>Сумма товаров</span>
            </div>
            <Button className='btn-primary large checkout-btn' onClick={handleCheckout}>
              К оформлению
            </Button>
          </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CartModal;
